/*
  ATLAS STOCK — PRODUCT MEDIA GALLERY

  Alt Text:
  Paradise Green 1
  Paradise Green 2
  Black 1
  Black 2

  Chức năng:
  - Chọn màu nào chỉ hiện ảnh màu đó.
  - Không phân biệt chữ hoa và chữ thường.
  - Loại ảnh màu khác khỏi slider mobile.
  - Mũi tên chỉ chuyển giữa ảnh của màu hiện tại.
  - Sắp xếp ảnh theo số cuối Alt Text.
  - Ẩn các chấm tròn trên mobile.
  - Không làm trắng gallery nếu Alt Text không khớp.
*/

(function () {
  'use strict';

  function normalizeAtlasText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function atlasImageMatchesColor(
    imageAlt,
    selectedColor
  ) {
    const alt =
      normalizeAtlasText(imageAlt);

    const color =
      normalizeAtlasText(
        selectedColor
      );

    if (!alt || !color) {
      return false;
    }

    return (
      alt === color ||
      alt.startsWith(color + ' ') ||
      alt.startsWith(color + '-') ||
      alt.startsWith(color + '_')
    );
  }

  function getAtlasImageNumber(
    altText
  ) {
    const match =
      String(altText || '').match(
        /(?:\s+|[-_])(\d+)\s*$/
      );

    return match
      ? parseInt(match[1], 10)
      : 9999;
  }

  function addAtlasGalleryStyles() {
    if (
      document.getElementById(
        'AtlasProductGalleryStyles'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'AtlasProductGalleryStyles';

    style.textContent = `
      @media screen and (max-width: 749px) {
        media-gallery .slider__dots {
          display: none !important;
        }

        media-gallery
        .slider-buttons--dots
        .slider__dots {
          display: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  addAtlasGalleryStyles();

  if (!customElements.get('media-gallery')) {
    customElements.define(
      'media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();

          this.elements = {
            liveRegion:
              this.querySelector(
                '[id^="GalleryStatus"]'
              ),

            viewer:
              this.querySelector(
                '[id^="GalleryViewer"]'
              ),

            thumbnails:
              this.querySelector(
                '[id^="GalleryThumbnails"]'
              )
          };

          this.mql =
            window.matchMedia(
              '(min-width: 750px)'
            );

          this.productInfo =
            document.getElementById(
              `ProductInfo-${this.dataset.section}`
            );

          this.prependMedia =
            this.dataset.disablePrepend !==
            'true';

          this.filteringOption =
            this.dataset.filteringOption;

          if (
            this.productInfo &&
            window.Shopify &&
            Shopify.postLinksRetry &&
            typeof this.productInfo
              .initShareLinks ===
              'function'
          ) {
            this.productInfo
              .initShareLinks();
          }

          if (this.elements.viewer) {
            this.elements.viewer
              .addEventListener(
                'slideChanged',
                debounce(
                  this.onSlideChanged
                    .bind(this),
                  250
                )
              );
          }

          if (this.elements.thumbnails) {
            this.elements.thumbnails
              .querySelectorAll(
                '[data-target]'
              )
              .forEach(
                (mediaToSwitch) => {
                  const button =
                    mediaToSwitch
                      .querySelector(
                        'button'
                      );

                  if (!button) return;

                  button.addEventListener(
                    'click',
                    this.setActiveMedia
                      .bind(
                        this,
                        mediaToSwitch
                          .dataset.target,
                        false
                      )
                  );
                }
              );
          }

          if (
            this.dataset
              .desktopLayout &&
            this.dataset
              .desktopLayout
              .includes('thumbnail') &&
            this.mql.matches
          ) {
            this.removeListSemantic();
          }
        }

        onSlideChanged(event) {
          if (
            !event.detail ||
            !event.detail
              .currentElement ||
            !this.elements.thumbnails
          ) {
            return;
          }

          const currentElement =
            event.detail
              .currentElement;

          const mediaId =
            currentElement
              .dataset.mediaId;

          if (!mediaId) return;

          const thumbnail =
            this.elements.thumbnails
              .querySelector(
                `[data-target="${mediaId}"]`
              );

          this.setActiveThumbnail(
            thumbnail
          );
        }

        showFilterableItem(item) {
          if (!item) return;

          item.hidden = false;

          item.classList.remove(
            'hidden'
          );

          item.setAttribute(
            'aria-hidden',
            'false'
          );

          item.style.removeProperty(
            'display'
          );
        }

        hideFilterableItem(item) {
          if (!item) return;

          item.hidden = true;

          item.classList.add(
            'hidden'
          );

          item.setAttribute(
            'aria-hidden',
            'true'
          );

          item.style.setProperty(
            'display',
            'none',
            'important'
          );
        }

        filterMedia(currentVariant) {
          if (
            !currentVariant ||
            !this.filteringOption
          ) {
            return [];
          }

          const selectedColor =
            normalizeAtlasText(
              currentVariant[
                this.filteringOption
              ] || ''
            );

          if (!selectedColor) {
            return [];
          }

          const mainMediaItems =
            Array.from(
              this.querySelectorAll(
                '.product__media-item[data-alt]'
              )
            );

          const thumbnailItems =
            Array.from(
              this.querySelectorAll(
                '.thumbnail-list__item[data-alt]'
              )
            );

          const paginationDots =
            Array.from(
              this.querySelectorAll(
                '.slider-counter__link[data-alt]'
              )
            );

          const allFilterableItems = [
            ...mainMediaItems,
            ...thumbnailItems,
            ...paginationDots
          ];

          const matchingMainMedia =
            mainMediaItems.filter(
              (item) => {
                const imageAlt =
                  item.dataset.alt || '';

                return (
                  atlasImageMatchesColor(
                    imageAlt,
                    selectedColor
                  ) ||
                  normalizeAtlasText(
                    imageAlt
                  ) ===
                    'always_display'
                );
              }
            );

          /*
            Không có ảnh khớp:
            hiện lại tất cả để tránh
            gallery bị trắng.
          */
          if (
            !matchingMainMedia.length
          ) {
            allFilterableItems
              .forEach(
                (item) => {
                  this.showFilterableItem(
                    item
                  );
                }
              );

            return mainMediaItems;
          }

          allFilterableItems.forEach(
            (item) => {
              const imageAlt =
                item.dataset.alt || '';

              const shouldShow =
                atlasImageMatchesColor(
                  imageAlt,
                  selectedColor
                ) ||
                normalizeAtlasText(
                  imageAlt
                ) ===
                  'always_display';

              if (shouldShow) {
                this.showFilterableItem(
                  item
                );
              } else {
                this.hideFilterableItem(
                  item
                );
              }
            }
          );

          /*
            Sắp xếp ảnh chính
            theo số cuối Alt Text.
          */
          matchingMainMedia.sort(
            (
              firstItem,
              secondItem
            ) => {
              return (
                getAtlasImageNumber(
                  firstItem
                    .dataset.alt
                ) -
                getAtlasImageNumber(
                  secondItem
                    .dataset.alt
                )
              );
            }
          );

          const mainList =
            this.querySelector(
              'ul.product__media-list'
            );

          if (mainList) {
            matchingMainMedia.forEach(
              (item) => {
                mainList.appendChild(
                  item
                );
              }
            );
          }

          /*
            Sắp xếp thumbnail
            theo số cuối Alt Text.
          */
          const matchingThumbnails =
            thumbnailItems.filter(
              (item) => {
                const imageAlt =
                  item.dataset.alt || '';

                return (
                  atlasImageMatchesColor(
                    imageAlt,
                    selectedColor
                  ) ||
                  normalizeAtlasText(
                    imageAlt
                  ) ===
                    'always_display'
                );
              }
            );

          matchingThumbnails.sort(
            (
              firstItem,
              secondItem
            ) => {
              return (
                getAtlasImageNumber(
                  firstItem
                    .dataset.alt
                ) -
                getAtlasImageNumber(
                  secondItem
                    .dataset.alt
                )
              );
            }
          );

          const thumbnailList =
            this.querySelector(
              'ul.thumbnail-list'
            );

          if (thumbnailList) {
            matchingThumbnails.forEach(
              (item) => {
                thumbnailList
                  .appendChild(item);
              }
            );
          }

          return matchingMainMedia;
        }

        getVisibleMediaItems() {
          if (!this.elements.viewer) {
            return [];
          }

          return Array.from(
            this.elements.viewer
              .querySelectorAll(
                '.product__media-item'
              )
          ).filter(
            (item) => {
              return (
                !item.hidden &&
                !item.classList
                  .contains('hidden') &&
                window
                  .getComputedStyle(
                    item
                  )
                  .display !== 'none'
              );
            }
          );
        }

        resetGallerySliders() {
          window.requestAnimationFrame(
            () => {
              if (
                this.elements.viewer &&
                typeof this.elements
                  .viewer.resetPages ===
                  'function'
              ) {
                this.elements.viewer
                  .resetPages();
              } else {
                if (
                  this.elements.viewer &&
                  typeof this.elements
                    .viewer.initPages ===
                    'function'
                ) {
                  this.elements.viewer
                    .initPages();
                }

                if (
                  this.elements.viewer &&
                  typeof this.elements
                    .viewer.update ===
                    'function'
                ) {
                  this.elements.viewer
                    .update();
                }
              }

              if (
                this.elements
                  .thumbnails &&
                typeof this.elements
                  .thumbnails
                  .resetPages ===
                  'function'
              ) {
                this.elements
                  .thumbnails
                  .resetPages();
              }

              window.requestAnimationFrame(
                () => {
                  if (
                    this.elements
                      .viewer &&
                    typeof this.elements
                      .viewer.update ===
                      'function'
                  ) {
                    this.elements
                      .viewer.update();
                  }
                }
              );
            }
          );
        }

        setActiveMedia(
          mediaId,
          prepend,
          filtering = false,
          currentVariant = null
        ) {
          let matchingMedia = [];

          if (
            filtering &&
            currentVariant
          ) {
            matchingMedia =
              this.filterMedia(
                currentVariant
              );
          }

          if (!this.elements.viewer) {
            return;
          }

          let activeMedia =
            this.elements.viewer
              .querySelector(
                `[data-media-id="${mediaId}"]`
              );

          const visibleMedia =
            this.getVisibleMediaItems();

          /*
            Ảnh variant không tồn tại,
            không có featured image hoặc
            thuộc màu khác:
            dùng ảnh đầu tiên của màu.
          */
          if (
            !activeMedia ||
            activeMedia.hidden ||
            activeMedia.classList
              .contains('hidden') ||
            window
              .getComputedStyle(
                activeMedia
              )
              .display === 'none'
          ) {
            activeMedia =
              matchingMedia[0] ||
              visibleMedia[0] ||
              null;
          }

          if (!activeMedia) {
            return;
          }

          this.elements.viewer
            .querySelectorAll(
              '[data-media-id]'
            )
            .forEach(
              (element) => {
                element.classList
                  .remove(
                    'is-active'
                  );
              }
            );

          activeMedia.classList.add(
            'is-active'
          );

          if (
            prepend &&
            this.prependMedia
          ) {
            const mediaParent =
              activeMedia.parentElement;

            if (mediaParent) {
              mediaParent.prepend(
                activeMedia
              );
            }

            if (
              this.elements.thumbnails
            ) {
              const activeThumbnail =
                this.elements.thumbnails
                  .querySelector(
                    `[data-target="${activeMedia.dataset.mediaId}"]`
                  );

              if (
                activeThumbnail &&
                activeThumbnail
                  .parentElement
              ) {
                activeThumbnail
                  .parentElement
                  .prepend(
                    activeThumbnail
                  );
              }
            }
          }

          if (
            filtering &&
            currentVariant
          ) {
            this.resetGallerySliders();
          }

          this.preventStickyHeader();

          window.setTimeout(
            () => {
              const mediaParent =
                activeMedia
                  .parentElement;

              if (mediaParent) {
                mediaParent.scrollTo({
                  left:
                    activeMedia
                      .offsetLeft,
                  top: 0,
                  behavior: 'auto'
                });
              }

              this.playActiveMedia(
                activeMedia
              );
            },
            80
          );

          if (
            !this.elements.thumbnails
          ) {
            return;
          }

          const activeThumbnail =
            this.elements.thumbnails
              .querySelector(
                `[data-target="${activeMedia.dataset.mediaId}"]`
              );

          this.setActiveThumbnail(
            activeThumbnail
          );

          if (activeThumbnail) {
            this.announceLiveRegion(
              activeMedia,
              activeThumbnail
                .dataset
                .mediaPosition
            );
          }
        }

        setActiveThumbnail(
          thumbnail
        ) {
          if (
            !this.elements.thumbnails ||
            !thumbnail
          ) {
            return;
          }

          this.elements.thumbnails
            .querySelectorAll(
              'button'
            )
            .forEach(
              (element) => {
                element
                  .removeAttribute(
                    'aria-current'
                  );
              }
            );

          const button =
            thumbnail
              .querySelector(
                'button'
              );

          if (button) {
            button.setAttribute(
              'aria-current',
              'true'
            );
          }

          if (
            typeof this.elements
              .thumbnails
              .isSlideVisible !==
              'function'
          ) {
            return;
          }

          if (
            this.elements
              .thumbnails
              .isSlideVisible(
                thumbnail,
                false,
                10,
                true
              )
          ) {
            return;
          }

          if (
            !this.elements
              .thumbnails.slider
          ) {
            return;
          }

          if (
            this.elements
              .thumbnails.vertical
          ) {
            this.elements
              .thumbnails.slider
              .scrollTo({
                top:
                  thumbnail.offsetTop,
                behavior: 'smooth'
              });
          } else {
            this.elements
              .thumbnails.slider
              .scrollTo({
                left:
                  thumbnail.offsetLeft,
                behavior: 'smooth'
              });
          }
        }

        announceLiveRegion(
          activeItem,
          position
        ) {
          if (
            !activeItem ||
            !this.elements.liveRegion
          ) {
            return;
          }

          const image =
            activeItem.querySelector(
              '.product__modal-opener--image img'
            );

          if (!image) return;

          image.onload = () => {
            this.elements.liveRegion
              .setAttribute(
                'aria-hidden',
                'false'
              );

            if (
              window
                .accessibilityStrings &&
              window
                .accessibilityStrings
                .imageAvailable
            ) {
              this.elements
                .liveRegion
                .innerHTML =
                window
                  .accessibilityStrings
                  .imageAvailable
                  .replace(
                    '[index]',
                    position || '1'
                  );
            }

            window.setTimeout(
              () => {
                this.elements
                  .liveRegion
                  .setAttribute(
                    'aria-hidden',
                    'true'
                  );
              },
              2000
            );
          };

          image.src = image.src;
        }

        playActiveMedia(
          activeItem
        ) {
          if (!activeItem) return;

          if (
            typeof window
              .pauseAllMedia ===
              'function'
          ) {
            window.pauseAllMedia();
          }

          const deferredMedia =
            activeItem.querySelector(
              '.deferred-media'
            );

          if (
            deferredMedia &&
            typeof deferredMedia
              .loadContent ===
              'function'
          ) {
            deferredMedia
              .loadContent(false);
          }
        }

        preventStickyHeader() {
          this.stickyHeader =
            this.stickyHeader ||
            document.querySelector(
              'sticky-header'
            );

          if (!this.stickyHeader) {
            return;
          }

          this.stickyHeader
            .dispatchEvent(
              new Event(
                'preventHeaderReveal'
              )
            );
        }

        removeListSemantic() {
          if (
            !this.elements.viewer ||
            !this.elements
              .viewer.slider
          ) {
            return;
          }

          this.elements.viewer
            .slider
            .setAttribute(
              'role',
              'presentation'
            );

          if (
            this.elements.viewer
              .sliderItems
          ) {
            this.elements.viewer
              .sliderItems
              .forEach(
                (slide) => {
                  slide.setAttribute(
                    'role',
                    'presentation'
                  );
                }
              );
          }
        }
      }
    );
  }
})();